// @generated by protoc-gen-es v2.14.1 with parameter "target=ts"
// @generated from file travplaces/v1/poi_search.proto (package travplaces.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_travplaces_v1_audit } from "./audit_pb";
import { file_travplaces_v1_authz } from "./authz_pb";
import type { Poi } from "./poi_pb";
import { file_travplaces_v1_poi } from "./poi_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file travplaces/v1/poi_search.proto.
 */
export const file_travplaces_v1_poi_search: GenFile = /*@__PURE__*/
  fileDesc("Ch50cmF2cGxhY2VzL3YxL3BvaV9zZWFyY2gucHJvdG8SDXRyYXZwbGFjZXMudjEikQEKEVNlYXJjaFBvaXNSZXF1ZXN0Eg8KB2NpdHlfaWQYASABKAkSCQoBcRgCIAEoCRIVCg1jYXRlZ29yeV9rZXlzGAMgAygJEhYKDnZpc2l0YWJsZV9vbmx5GAQgASgIEg0KBWxpbWl0GAUgASgFEg4KBm9mZnNldBgGIAEoBRISCgp3aXRoX3RvdGFsGAcgASgIIlcKElNlYXJjaFBvaXNSZXNwb25zZRIgCgRwb2lzGAEgAygLMhIudHJhdnBsYWNlcy52MS5Qb2kSEAoIaGFzX21vcmUYAiABKAgSDQoFdG90YWwYAyABKAUycgoQUG9pU2VhcmNoU2VydmljZRJeCgpTZWFyY2hQb2lzEiAudHJhdnBsYWNlcy52MS5TZWFyY2hQb2lzUmVxdWVzdBohLnRyYXZwbGFjZXMudjEuU2VhcmNoUG9pc1Jlc3BvbnNlIguK6jADCgEKkOowAUKpAQoRY29tLnRyYXZwbGFjZXMudjFCDlBvaVNlYXJjaFByb3RvUAFaL3RyYXZwbGFjZXMvZ2VuL3Byb3RvL3RyYXZwbGFjZXMvdjE7dHJhdnBsYWNlc3YxogIDVFhYqgINVHJhdnBsYWNlcy5WMcoCDVRyYXZwbGFjZXNcVjHiAhlUcmF2cGxhY2VzXFYxXEdQQk1ldGFkYXRh6gIOVHJhdnBsYWNlczo6VjFiBnByb3RvMw", [file_travplaces_v1_audit, file_travplaces_v1_authz, file_travplaces_v1_poi]);

/**
 * @generated from message travplaces.v1.SearchPoisRequest
 */
export type SearchPoisRequest = Message<"travplaces.v1.SearchPoisRequest"> & {
  /**
   * Empty means every city: the planner's start and destination pickers
   * search across cities, because a route may run from one into the next.
   *
   * @generated from field: string city_id = 1;
   */
  cityId: string;

  /**
   * optional name ILIKE filter (empty = no filter)
   *
   * @generated from field: string q = 2;
   */
  q: string;

  /**
   * optional category-key filter (empty = all)
   *
   * @generated from field: repeated string category_keys = 3;
   */
  categoryKeys: string[];

  /**
   * when true, only visitable categories
   *
   * @generated from field: bool visitable_only = 4;
   */
  visitableOnly: boolean;

  /**
   * max rows (defaults to 50 when <= 0)
   *
   * @generated from field: int32 limit = 5;
   */
  limit: number;

  /**
   * How many rows to skip, for a picker fetching the next page as somebody
   * scrolls. The ordering is total, so a row cannot move between pages.
   *
   * @generated from field: int32 offset = 6;
   */
  offset: number;

  /**
   * Also count every match, not just this page.
   *
   * For the browser, which prints "40 of 11,351 places" so somebody can
   * see what they are working through. Asked for rather than always
   * returned: a picker showing ten rows has no use for the figure, and
   * counting every match on every keystroke is work nobody reads.
   *
   * @generated from field: bool with_total = 7;
   */
  withTotal: boolean;
};

/**
 * Describes the message travplaces.v1.SearchPoisRequest.
 * Use `create(SearchPoisRequestSchema)` to create a new message.
 */
export const SearchPoisRequestSchema: GenMessage<SearchPoisRequest> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_poi_search, 0);

/**
 * @generated from message travplaces.v1.SearchPoisResponse
 */
export type SearchPoisResponse = Message<"travplaces.v1.SearchPoisResponse"> & {
  /**
   * @generated from field: repeated travplaces.v1.Poi pois = 1;
   */
  pois: Poi[];

  /**
   * True when another page exists. Read from one row fetched beyond the
   * limit and dropped, so it is exact rather than inferred from a full page.
   *
   * @generated from field: bool has_more = 2;
   */
  hasMore: boolean;

  /**
   * Every match, ignoring the page. Zero unless with_total was asked for.
   *
   * @generated from field: int32 total = 3;
   */
  total: number;
};

/**
 * Describes the message travplaces.v1.SearchPoisResponse.
 * Use `create(SearchPoisResponseSchema)` to create a new message.
 */
export const SearchPoisResponseSchema: GenMessage<SearchPoisResponse> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_poi_search, 1);

/**
 * PoiSearchService searches POIs within a city with optional text and
 * category filters. It reuses the Poi message from poi.proto.
 *
 * @generated from service travplaces.v1.PoiSearchService
 */
export const PoiSearchService: GenService<{
  /**
   * SearchPois returns active POIs in a city matching the filters, name-ordered.
   *
   * @generated from rpc travplaces.v1.PoiSearchService.SearchPois
   */
  searchPois: {
    methodKind: "unary";
    input: typeof SearchPoisRequestSchema;
    output: typeof SearchPoisResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_travplaces_v1_poi_search, 0);

